import React, { useEffect, useState, useRef } from "react";
import Announcement from "./layouts/Announcement";
import TrendingTopics from "./TrendingTopics";
import ReportPost from "./popups/ReportPost";
import MakeFavourite from "./popups/MakeFavourite";
import CommunityAbout from "./layouts/CommunityAbout";
import CommunityTopBar from "./layouts/CommunityTopBar";
import ListFeed from "./ListFeed";
import CreatePost from "./CreatePost";
import Spinner from "../../commonComponents/Spinner";
import user from "../../assets/img/user 1.svg";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import { useNavigate, useLocation } from 'react-router-dom';
import Confirmpopup from "../../commonComponents/Confirmpopup";
import {
  listCommunityPosts,getTrendingTopics,
  savePostComment, savePostShortlist, savePostLike, deletePost
} from "../../services/apiPosts";

const Post = () => {
  const MAX_COMMENT_LENGTH = 2000;
  const [characterLimit, setCharacterLimit] = useState({
    isOverLimit: false,
    remaining: MAX_COMMENT_LENGTH,
    limitedText: ''
  });
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [loading, setLoading] = useState(true);
  const [Feeds, setFeeds] = useState([]);
  const [comment, setComment] = useState({});
  const [show, setShow] = useState(false);
  const [showreport, setShowReport] = useState(false);
  const [showfav, setFavourite] = useState(false);
  const [reportId, setReportId] = useState(false);
  const [favouriteUserId, setFavouriteUserId] = useState(false);
  const [favouriteUserName,setFavouriteUserName] = useState("");
  const [favourites, setFavourites] = useState({});
  const [likedPosts, setLikedPosts] = useState({});
  const [savedPost, setsavedPosts] = useState({});
  const [FavStatus, setFavStatus] = useState();
  const [EditStatus, setEditStatus] = useState(false);
  const [EditFeed, setEditFeed] = useState([]);
   const[isSucess,SetSucess]=useState(false);
   const[ResponseMessage,SetResponseMessage]=useState("");
   const[isConfirm,setConfirm]=useState(false);
   const[DeletPostid,setDeltePostId]=useState('');
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true); // pagination 
  const [Topics, setTopics] = useState([]);
  const [moreTopics, setMoreTopics] = useState([]);
  const limit = 20; // Number of posts per fetch
  const location = useLocation();
  const lastPostRef = useRef(null);
  const OpenPopup = () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);
    setEditStatus(false);
  }

  const fetchAllTopics = async (topicpaylod) => {
      try {
        let listTopics = await getTrendingTopics(topicpaylod);
        if (listTopics.status === true)
          setTopics(listTopics?.trendingTopics || []);
          setMoreTopics(listTopics?.allTopics || []);
      } catch (e) {
        console.log(e);
      }
  
    };

  useEffect(() => {
    let listpayload = {
      userid: userData._id,
      communityid: localStorage.getItem("communityId"),
      topics: [],
      offset: 0,
      limit: limit
    };
    localStorage.setItem("postpayload", JSON.stringify(listpayload));
    setOffset(0); // Reset offset
    setHasMore(true); // Reset hasMore
    setFeeds([]); // Clear existing feeds
    fetchAllFeeds(listpayload);
    fetchAllTopics({ communityid: [localStorage.getItem('communityId')] });
  }, [location]);
  /* for pagination */
  const loadMoreFeeds = async (loadmorePayload) => {
    if (!hasMore || loading) return;
    setLoading(true);
    
    localStorage.setItem('postpayload', JSON.stringify(loadmorePayload));
    let listFeeds = await listCommunityPosts(loadmorePayload);
    if (listFeeds.status === true) {
      if (listFeeds.posts.length === 0) {
        setHasMore(false); // No more posts to load
      } else {

        setFeeds((prevFeeds) => [...prevFeeds, ...listFeeds.posts]); // Append new posts
        setOffset(loadmorePayload.offset); // Update offset
        const initialLikedPosts = {};
        const intialFavourites = {};
        listFeeds.posts.forEach(post => {
          // Check if userlike array contains an object with isliked equal to 1
          if (post.userlike.length > 0 && post.userlike[0].isliked === 1) {
            initialLikedPosts[post._id] = true; // User liked the post
          } else {
            initialLikedPosts[post._id] = false; // User did not like the post
          }
          if (post.favouritemember.length > 0 && post.favouritemember[0].isfavourite === 1) {
            intialFavourites[post.user[0]._id] = true;
          } else {
            intialFavourites[post.user[0]._id] = false;
          }
        });
        // setLikedPosts(initialLikedPosts);
        // setFavourites(intialFavourites);
        setLikedPosts((prev) => ({ ...prev, ...initialLikedPosts }));
        setFavourites((prev) => ({ ...prev, ...intialFavourites }));


      }


    }
    setLoading(false);

  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          const newOffset = offset + limit;
          const listpayload = JSON.parse(localStorage.getItem('postpayload'));
          listpayload.offset = newOffset;
      
          loadMoreFeeds(listpayload);
        }
      },
      { threshold: 0.1 } // Reduced threshold for earlier triggering
    );

    if (lastPostRef.current) {
      observer.observe(lastPostRef.current);
    }

    return () => {
      if (lastPostRef.current) {
        observer.unobserve(lastPostRef.current);
      }
    };
  }, [hasMore, offset, loading]); // Add loading to dependencies
  /* End pagination */

  

  const showReport = (postid) => {
    setShow(true);
    setShowReport(true);
    setReportId(postid)
  }
  const HideReport = () => {
    setShowReport(false);
  }
  const showFavourite = (userId,favname,arraylength) => {
    
    setFavourite(true);
    setFavouriteUserId(userId);
    setFavouriteUserName(favname);
     setFavStatus(favourites[userId] || false);
   
  }
  const HideFavourite = () => {
    setFavourite(false);
  }
  const toggleFavourite = (userId, newstatus) => {
    //const isUsrId = favourites[userId];
    setFavourites((prevFavourites) => ({
      ...prevFavourites,
      [userId]: newstatus
    }));
    
  };

  const handleshortlist = async (postid) => {
    let shortlistpayload = { postid: postid, userid: userData._id }
    let shortResponse = await savePostShortlist(shortlistpayload);
    if (shortResponse.status === true) {
      setsavedPosts((prevSavedPosts) => ({
        ...prevSavedPosts,
        [postid]: !prevSavedPosts[postid], // Toggle the saved status
      }));
      SetSucess(true);
      SetResponseMessage("Post is saved!");
     

    }

  }
  const handleLike = async (postid) => {
    const isLiked = likedPosts[postid]; // Get current liked status
    let likePayload = { postid: postid, userid: userData._id };
    let likeresponse = await savePostLike(likePayload);
    if (likeresponse.status === true) {
      // Update likedPosts state
      setLikedPosts((prevLikes) => ({
        ...prevLikes,
        [postid]: !isLiked, // Toggle the liked status
      }));
    }
  };

  const handleDelete = async (postid) => {
      setConfirm(false);
    let deletepayload = { postid: postid };
    let response = await deletePost(deletepayload);
    if (response.status === true) {
      SetSucess(true);
      SetResponseMessage("Post is Deleted!");
      setFeeds(prevFeeds => prevFeeds.filter(post => post._id !== postid));
      
    }

  }
  const DeletPost = async (postid) => {
        setConfirm(true);
        setDeltePostId(postid);
  };
  const handleEdit = (feed) => {
    setEditFeed(feed);
    setEditStatus(true);
    setOpen(true);
  }

  const handleCommentChange = (postId, value) => {
      const remaining = MAX_COMMENT_LENGTH - value.length;
     const isOverLimit = remaining < 0;
  
  setCharacterLimit(prev => ({
    ...prev,
    [postId]: {
      isOverLimit,
      remaining: Math.max(0, remaining), // Ensure it doesn't go negative
      limitedText: value.slice(0, MAX_COMMENT_LENGTH)
    }
  }));

  setComment(prev => ({
    ...prev,
    [postId]: value.slice(0, MAX_COMMENT_LENGTH)
  }));
    
  };
  const handleCommentSubmit = async (postid) => {
   
    let commentPayload = { comment: comment[postid], postid: postid, userid: userData._id }
    let response = await savePostComment(commentPayload);
    if (response.status === true){
       setComment((prevComments) => ({
        ...prevComments,
        [postid]: '',
      }));

    }else{

       SetSucess(true);
       SetResponseMessage(response.message);

    }
     return response;
  };

  const handleCommentClear = (postId) => {
    setComment((prevComments) => ({
      ...prevComments,
      [postId]: '',
    }));
  }

  const fetchAllFeeds = async (listpayload) => {
    setHasMore(true);
    setLoading(true);
    setFeeds([]); // Clear existing feeds when fetching new ones
    setOffset(0); // Reset offset
    let listFeeds = await listCommunityPosts(listpayload);
    if (listFeeds.status === true) {
    
       
     setFeeds((prevFeeds) => [...prevFeeds, ...listFeeds.posts]); // Append new posts
     // this is commented on changed on 25-0-2025
      //setOffset(prevOffset => prevOffset + listFeeds.posts.length); // Update offset
      const initialLikedPosts = {};
      const intialFavourites = {};
      listFeeds.posts.forEach(post => {
        // Check if userlike array contains an object with isliked equal to 1
        if (post.userlike.length > 0 && post.userlike[0].isliked === 1) {
          initialLikedPosts[post._id] = true; // User liked the post
        } else {
          initialLikedPosts[post._id] = false; // User did not like the post
        }
        if (post.favouritemember.length > 0 && post.favouritemember[0].isfavourite === 1) {
          intialFavourites[post.user[0]._id] = true;
        } else {
          intialFavourites[post.user[0]._id] = false;
        }
      });
      setLikedPosts(initialLikedPosts);
      setFavourites(intialFavourites);

    }

    setLoading(false);

  }

  return (

    <div >
      <CommunityTopBar communityName={localStorage.getItem("communityName")}></CommunityTopBar>
      <div className="community-features main ml-0">


        <div className="contents ml-0">
          <div className="">
           
            <TrendingTopics fetchAllFeeds={fetchAllFeeds} Topics={Topics} moreTopics={moreTopics} communityId={localStorage.getItem("communityId")}></TrendingTopics>

            <div className="create-post-section">
              <img src={user} className="create-post-avtar " />
              <button onClick={() => { OpenPopup() }} className="createpost-wrp" >Create Post</button>
            </div>




            {Feeds.length === 0 && loading  ? (
              <div className="d-flex justify-content-center my-5">
                <Spinner />
              </div>
            ) : (Feeds.map((post, index) => {
              return (
                <ListFeed  key={post._id} post={post} index={index}
                  ref={index === Feeds.length - 1 ? lastPostRef : null}
                  favourites={favourites} showFavourite={showFavourite}
                  userData={userData} setShow={setShow}
                  DeletPost={DeletPost} showReport={showReport}
                  likedPosts={likedPosts} handleLike={handleLike}
                  savedPost={savedPost} handleshortlist={handleshortlist}
                  comment={comment} handleCommentChange={handleCommentChange}
                  maxCommentLength={MAX_COMMENT_LENGTH}
                   commentLimit={characterLimit[post._id] || {
                    isOverLimit: false,
                    remaining: MAX_COMMENT_LENGTH,
                    limitedText: ''
                  }}
                  handleCommentSubmit={handleCommentSubmit} handleEdit={handleEdit}
                  handleCommentClear={handleCommentClear} toggleFavourite={toggleFavourite}>
                </ListFeed>
              )
            })


            )}

{/* {loading && Feeds.length > 0 && (
                  <div className="d-flex justify-content-center my-3">
                    <Spinner />
                  </div>
                )} */}


          </div>
          
        </div>
        <CommunityAbout></CommunityAbout>
      </div>
      <CreatePost openPop={open} closePop={ClosePopup} EditStatus={EditStatus} EditFeed={EditFeed} fetchAllFeeds={fetchAllFeeds}></CreatePost>
      <ReportPost showReport={showreport} HideReport={HideReport} reportId={reportId}></ReportPost>
      <MakeFavourite showFavourite={showfav} HideFavourite={HideFavourite} favouriteUserId={favouriteUserId} favouriteUserName={favouriteUserName} toggleFavourite={toggleFavourite} FavStatus={FavStatus}></MakeFavourite>
       {isConfirm && (<Confirmpopup 
                isConfirm={isConfirm}
                DeletPostid={DeletPostid} 
                handleDelete={handleDelete}
                type="post"
                CancelPopup={() => { 
                  setConfirm(false);
                }} 
                                  
              />)}        
      {isSucess && (<ResponsePopup 
                isSucess={isSucess} 
                CancelPopup={() => { 
                 SetSucess(false);
                }} 
                message={ResponseMessage}
              />)}
    </div>

  );

};
export default Post;